import React , { createContext, useReducer } from 'react';
import { MenuReducer } from '../reducers/MenuReducer';

export const MenuContext = createContext();

const MenuContextProvider = (props) => {
	const [menus, dispatch] = useReducer(MenuReducer, {
		menuList: ['Beranda', 'Proyek', 'Layanan'],
		active: null
	});

	return(
		<MenuContext.Provider value={ { menus, dispatch } }>
			{props.children}		
		</MenuContext.Provider>
	);
}

export default MenuContextProvider;